'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class riskStateOfPlayModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getValue(name){
		switch(name){			
			case 'materialize':
			case 'apply_mesures':
				return this.getClassifValue(name, 'yesno');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
}